export default {
  mounted() {
    window.addEventListener('scroll', this.scrollHandler||function(){});
  }
} 